import { ApiClient } from "@modules/core/api/client/apiClient"
import { type BoxPromoCodeApiGateway } from "@modules/promoCode/gateway/boxPromoCodeApi.gateway"
import { type BoxPromoCodeDto } from "@modules/promoCode/gateway/boxPromoCodeDto"
import { type BoxPromoCodeDraft } from "@modules/promoCode/types/boxPromoCodeTypes"

export class BoxPromoCodeApi implements BoxPromoCodeApiGateway {
  private baseUrl = "/box/promo-codes"

  constructor(private api: ApiClient) {}

  async getBoxPromoCodes(expired: boolean): Promise<BoxPromoCodeDto[]> {
    const result = await this.api.get<BoxPromoCodeDto[]>(`${this.baseUrl}`, { params: { expired } })
    return result.data
  }

  async createBoxPromoCode(promoCodeDraft: BoxPromoCodeDraft) {
    const resultDto = await this.api.post<BoxPromoCodeDto>(`${this.baseUrl}`, promoCodeDraft)
    return resultDto.data
  }

  async updateBoxPromoCode(id: string, promoCodeDraft: BoxPromoCodeDraft) {
    const resultDto = await this.api.put<BoxPromoCodeDto>(`${this.baseUrl}/${id}`, promoCodeDraft)
    return resultDto.data
  }

  async deleteBoxPromoCode(id: string) {
    await this.api.delete(`${this.baseUrl}/${id}`)
  }
}
